import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    transfertDemandeRequest: ['response'],
    transfertDemandeSuccess: ['loading', 'response'],
    transfertDemandeFailure: ['error'],
})

export const transfertDemandeTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const transfertDemandeRequest = state => state.merge({ loading: true })

const transfertDemandeSuccess = (state, { loading }) => {
    const { data } = loading
    return state.merge({
        loading: false,
        error: false,
        response: data,
    })
}

const transfertDemandeFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        loading: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.TRANSFERT_DEMANDE_REQUEST]: transfertDemandeRequest,
    [Types.TRANSFERT_DEMANDE_SUCCESS]: transfertDemandeSuccess,
    [Types.TRANSFERT_DEMANDE_FAILURE]: transfertDemandeFailure,
})
